import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const tPBrandmarkMonochromeGreenRGB1 = svgToTinyDataUri(
  `<svg viewBox="0 0 126 124" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M62.9998 0L81.7717 41.1527H126L89.1147 66.5942L107.886 107.747L62.9998 77.9999L18.1139 107.747L36.8858 66.5942L0 41.1527H44.2283L62.9998 0Z" fill="#00B67A"/>
<path d="M90.3125 75.9619L85.6406 65.0562L62.9998 77.9999L90.3125 75.9619Z" fill="#005128"/>
</svg>`
);
